<div class="inline-profile">
    {{ 'menu.welcome' | translate }} <strong>{{ user?.name }}</strong>

    <div>
        <button class="btn btn-sm btn-outline-info" (click)="logout()">{{ 'menu.logout' | translate }}</button>
    </div>
</div>
